import Logger from '../../../../../../../../../utility/services/Logger';

/**
 * For sibling draggable elements
 */
const setCollapseForSiblings = (params) => {
  const { editor, setCollapse, collapse, collapseVal, dragType } = params;
  const {
    value: {
      document: { key: documentKey },
    },
  } = editor;
  setCollapse({
    collapse: {
      ...collapse,
      document: {
        ...collapse.document,
        [documentKey]: collapseVal,
      },
    },
    dragType,
  });
};

export default (params) => {
  const { el, collapseVal, setSnackBar } = params;
  setTimeout(() => {
    try {
      el.style.display = collapseVal ? 'none' : 'grid';
      setCollapseForSiblings(params);
    } catch (err) {
      Logger.LogError(err);
      setCollapseForSiblings(params);
      setSnackBar('setSnackBar');
    }
  }, 0);
};
